<template>
  <div :class="name">
    <el-table :id="`${name}`"
              :class="`${name}`"
              :data="members"
              border
              v-loading="isLoading"
              :row-class-name="({ row }) => row.id"
              :row-key="row => row.id"
              :expand-row-keys="expandRowKeys"
              @expand-change="handleSelectMember"
              size="mini"
              :fit="true">
      <el-table-column type="expand"
                       :column-key="`${'expand'}`">
        <template slot-scope="props">
          <el-tabs class="permission">
            <!-- ------------------------------------------------------------------ -->
            <el-tab-pane :label="`${props.row.name}님의 권한 보기`"
                         v-if="props.row.occupation.length !== 0">
              <div class="permission">
                <div v-for="(service, serviceId) in deleteAnEmptyPermissionList(props.row.viewData)"
                     :key="`service_${serviceId}`">
                  <h3 style="padding: 3px; background-color: #eee;">{{services[serviceId].name}}</h3>
                  <el-row :gutter="24">
                    <el-col v-for="(domain, domainId) in service"
                            :key="`domain_${domainId}`"
                            :xs="8" :sm="6" :md="4" :lg="3" :xl="1">
                      <div>
                        <h4>{{services[serviceId].range_group[domainId].full_name}}</h4>
                        <ul style="margin: 0 0 1rem 0; padding: 0 0 0 1rem">
                          <li v-for="(action, actionId) in domain"
                              :key="`action_${actionId}`">
                            <router-link :to="`/permission?serviceId=${serviceId}&domainId=${domainId}&actionId=${actionId}`"
                                         :class="getClass(action)">
                              {{action.id}}
                            </router-link>
                          </li>
                        </ul>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-tab-pane>
            <!-- ------------------------------------------------------------------ -->
            <el-tab-pane label="직무"
                         v-if="copiedMember && checkLoginUserPermission(['admin_authority'])">
              <br>사 번 :
              <el-input size="mini"
                        placeholder="사번 입력"
                        style="width: 200px"
                        :disabled="copiedMember.company === 'sundaytoz'"
                        v-model="copiedMember.id"></el-input>
              <br>이 름 :
              <el-input size="mini"
                        placeholder="이름 입력"
                        style="width: 200px"
                        :disabled="copiedMember.company === 'sundaytoz'"
                        v-model="copiedMember.name"></el-input>
              <br>이메일:
              <el-input size="mini"
                        placeholder="이메일 입력"
                        style="width: 200px"
                        :disabled="copiedMember.company === 'sundaytoz'"
                        v-model="copiedMember.email"></el-input>
              <br>직 종 :
              <el-select v-model="copiedMember.occupation"
                         size="mini"
                         multiple
                         placeholder="직종 선택">
                <el-option v-for="(category, categoryId) in categories"
                           :key="categoryId"
                           :label="category.name"
                           :value="categoryId">
                </el-option>
              </el-select>
              <br>직 책 :
              <el-select v-model="copiedMember.position"
                         size="mini"
                         multiple
                         placeholder="직책 선택">
                <el-option v-for="(category, categoryId) in positions"
                           :key="categoryId"
                           :label="category.name"
                           :value="categoryId">
                </el-option>
              </el-select>
              <br><br>

              <div>
                <el-button @click="handleEditMember"
                           size="mini"
                           type="warning">등록</el-button>
              </div>
            </el-tab-pane>
            <!-- ------------------------------------------------------------------ -->
            <el-tab-pane label="팀원의 권한 변경 요청"
                         v-if="selectedMember
                         && copiedMember
                         && checkLoginUserPermission(['request', 'admin_authority'])">
              <ul>
                <li class="default">
                  * blue: 기존에 보유한 권한
                </li>
                <li class="removeException">
                  * yellow: 삭제 요청 될 권한
                </li>
                <li class="addException">
                  * blue: 부여 요청 될 권한
                </li>
              </ul>

              <el-tabs type="border-card">
                <el-tab-pane v-for="(affiliatedTeam, affiliatedTeamId) in copiedMember.affiliatedTeams"
                             v-if="checkLoginUserPermission(['request', 'admin_authority'], affiliatedTeamId)"
                             :key="`affiliatedTeam_${affiliatedTeamId}`"
                             :label="teams[affiliatedTeamId].name">
                  <template v-if="selectedMember.affiliatedTeams[affiliatedTeamId].proc_status === 2">
                    <template v-if="selectedMember.affiliatedTeams[affiliatedTeamId].agreements.length">
                      <span v-for="(agreement, index) in selectedMember.affiliatedTeams[affiliatedTeamId].agreements"
                            :key="`agreement_${index}`">
                      {{agreement.serviceId}},
                    </span>
                      서비스에 권한 요청 중입니다.
                    </template>
                    <template v-else>
                      최종 승인 중입니다.
                    </template>
                  </template>
                  <template v-else>
                    <el-tabs tab-position="left">
                      <el-tab-pane v-for="(service, serviceId) in affiliatedTeam.viewData"
                                   :key="`service_${serviceId}`"
                                   v-if="(serviceId === 'authority') ?
                                   checkLoginUserPermission(['admin_authority']) :
                                   teams[affiliatedTeamId].available_services.includes(serviceId)"
                                   :label="serviceId">
                        <el-card class="box-card"
                                 shadow="hover"
                                 v-if="teams[affiliatedTeamId].viewData[serviceId].checkTag !== ''">
                          <el-form label-position="left"
                                   inline
                                   class="demo-table-expand">
                            <el-form-item label="범위 :">
                              <el-checkbox v-model="affiliatedTeam.useRangeGroup"
                                           :label="affiliatedTeam.tags[serviceId]"
                                           @change="changeTag(copiedMember, affiliatedTeamId, serviceId)">
                                #{{affiliatedTeam.tags[serviceId]}}
                              </el-checkbox>
                            </el-form-item>
                            <br>
                            <el-form-item label="권한 :">
                              <el-checkbox-group v-model="affiliatedTeam.actions[serviceId]">
                                <el-checkbox v-for="(action, index) in services[serviceId].action_group"
                                             :key="index"
                                             :label="action.id"
                                             @change="changeTag(copiedMember, affiliatedTeamId, serviceId)">
                                  {{action.title}}
                                </el-checkbox>
                              </el-checkbox-group>
                            </el-form-item>
                          </el-form>
                        </el-card>
                        <br>
                        <br>
                        <el-row :gutter="24">
                          <el-col v-for="(domain, domainId) in service"
                                  :key="`domain_${domainId}`"
                                  :class="getTeamPermission(affiliatedTeam.id, serviceId, domainId)"
                                  :xs="8" :sm="6" :md="4" :lg="3" :xl="1">
                              {{services[serviceId].range_group[domainId].full_name}}
                            <ul style="padding-left: 0">
                              <li v-for="(action, actionId) in domain"
                                  :key="`action_${actionId}`"
                                  style="list-style: none; white-space: normal">
                                <el-checkbox v-model="action.selected"
                                             :disabled="action.isFilter"
                                             @change="changeAction(serviceId, domainId, actionId, affiliatedTeam.id)">
                                  <span :class="getClass(action)">{{services[serviceId].action_group[actionId].title}} {{action.request}}</span>
                                </el-checkbox>
                              </li>
                            </ul>
                          </el-col>
                        </el-row>
                      </el-tab-pane>
                    </el-tabs>
                    <div v-if="affiliatedTeam.agreements.length > 0">
                      <div>
                        <el-input size="mini"
                                  placeholder="권한 요청 사유"
                                  style="width: 200px"
                                  v-model="affiliatedTeam.reason"></el-input>
                        <el-button @click="handleEditAffiliatedTeamRoleRequest(affiliatedTeam.id)"
                                   size="mini"
                                   type="warning">권한 합의 요청</el-button>
                      </div>
                    </div>
                  </template>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <!-- ------------------------------------------------------------------ -->
            <el-tab-pane label="요청 받은 권한 보기"
                         v-if="selectedMember
                         && copiedMember
                         && selectedMember.proc_status !== 1
                         && checkLoginUserPermission(['admin_service', 'admin_authority'])">

              <el-tabs  tab-position="left">
                <el-tab-pane v-for="(affiliatedTeam, affiliatedTeamId) in selectedMember.affiliatedTeams"
                             v-if="affiliatedTeam.proc_status === 2
                             && checkLoginUserPermission(['admin_service', 'admin_authority'], affiliatedTeamId)"
                             :key="`affiliatedTeam_${affiliatedTeamId}`"
                             :label="teams[affiliatedTeamId].name">
                  <template v-if="affiliatedTeam.agreements.length === 0">
                    <el-input size="mini"
                              placeholder="승인 사유"
                              style="width: 200px"
                              v-model="affiliatedTeam.approval.comment"></el-input>
                    <el-button @click="handleEditAffiliatedTeamRoleRequestApprove(affiliatedTeam, true)"
                               size="mini"
                               type="warning">결제승인</el-button>
                    <el-button @click="handleEditAffiliatedTeamRoleRequestApprove(affiliatedTeam, false)"
                               size="mini"
                               type="warning">결제반려</el-button>
                  </template>

                  <div v-for="(service, serviceId) in affiliatedTeam.viewData"
                       :key="`service_${serviceId}`"
                       :label="serviceId">
                    <div v-for="(agreement) in affiliatedTeam.agreements"
                         :key="agreement.serviceId"
                         v-if="agreement.serviceId === serviceId">
                      <el-card>
                        <div slot="header" class="clearfix" style="overflow: hidden">
                          <h2 style="float: left; padding-right: 2rem" type="text">{{services[agreement.serviceId].name}}</h2>
                          <p style="float: left;">
                            {{teams[affiliatedTeamId].name}}팀장({{affiliatedTeam.requestor}})님이<br>
                            <strong>"{{affiliatedTeam.reason}}"</strong>의 이유로<br>
                            아래 나열된 권한 획득을 {{loginUser.name}}님에게 요청을 하였습니다.<br>
                            확인 후 하단에 이유와 합의 승인버튼을 클릭해 주세요.
                          </p>
                        </div>

                        <ul>
                          <li class="default">
                            * blue: 기존에 보유한 권한
                          </li>
                          <li class="removeException">
                            * yellow: 삭제 요청된 권한
                          </li>
                          <li class="addException">
                            * blue: 부여 요청된 권한
                          </li>
                        </ul>

                        <el-card class="box-card"
                                 shadow="hover"
                                 v-if="teams[affiliatedTeamId].viewData[serviceId].checkTag !== ''">
                          <el-form label-position="left"
                                   inline
                                   class="demo-table-expand">
                            <el-form-item label="#tag :">
                              <el-checkbox v-model="affiliatedTeam.useRangeGroup"
                                           :label="affiliatedTeam.tags[serviceId]"
                                           @change="changeTag(selectedMember, affiliatedTeamId, serviceId)">
                              </el-checkbox>
                            </el-form-item>
                            <br>
                            <el-form-item label="권한 :">
                              <el-checkbox-group v-model="affiliatedTeam.actions[serviceId]">
                                <el-checkbox v-for="(action, index) in services[serviceId].action_group"
                                             :key="index"
                                             :label="action.id"
                                             @change="changeTag(selectedMember, affiliatedTeamId, serviceId)">
                                  {{action.title}}
                                </el-checkbox>
                              </el-checkbox-group>
                            </el-form-item>
                          </el-form>
                        </el-card>
                        <br>
                        <br>
                        <el-row :gutter="24">
                          <el-col v-for="(domain, domainId) in service"
                                  :key="`domain_${domainId}`"
                                  :class="getTeamPermission(affiliatedTeam.id, serviceId, domainId)"
                                  :xs="8" :sm="6" :md="4" :lg="3" :xl="1">
                            {{services[serviceId].range_group[domainId].full_name}}
                            <ul style="padding-left: 0">
                              <li v-for="(action, actionId) in domain"
                                  :key="`action_${actionId}`"
                                  style="list-style: none; white-space: normal">
                                <el-checkbox v-model="action.selected"
                                             :disabled="action.isFilter"
                                             @change="changeAction(serviceId, domainId, actionId, affiliatedTeam.id)">
                                  <span :class="getClass(action)">{{action.id}}, {{action.request}}</span>
                                </el-checkbox>
                              </li>
                            </ul>
                          </el-col>
                        </el-row>
                        <br>
                        <br>
                        <template v-if="!agreement.agree">
                          {{services[agreement.serviceId].name}} :
                          <el-input size="mini"
                                    placeholder="승인 사유"
                                    style="width: 200px"
                                    v-model="agreement.comment"></el-input>
                          <el-button @click="handleEditAffiliatedTeamRoleRequestAgree(affiliatedTeam.request_id, agreement, true)"
                                     size="mini"
                                     type="warning">합의승인</el-button>
                        </template>
                      </el-card>
                      <br>


                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <!-- ------------------------------------------------------------------ -->
          </el-tabs>
        </template>
      </el-table-column>
      <template v-for="(key) in localIndicator">
        <el-table-column :prop="`${key}`"
                         :key="key"
                         :label="key"
                         :sortable="true"
                         :column-key="key">
          <template slot-scope="scope">
            <template v-if="key === 'name'">
              <span style="background-color: white">{{scope.row.id}}</span><br>
              <strong :class="scope.row.id">{{getName(key, scope.row)}}</strong><br>
              <span>
                직종: <template v-for="(occupation) in scope.row.occupation">{{categories[occupation].name}}</template>
              </span><br>
              <span>
                직책: <template v-for="(position) in scope.row.position">{{positions[position].name}}</template>
              </span><br>
              <span>제직 상태: {{scope.row.user_status === 1 ? '재직중' : '휴직중'}}</span>
            </template>
            <template v-else-if="key === 'img_url'">
              <el-image
                style="width: 100px; height: 100px "
                :style="scope.row.proc_status === 2 ? 'border:2px solid red' : 'border:2px solid white'"
                :src="scope.row.img_url"
                fit="cover">
              </el-image>
            </template>
            <template v-else-if="key === '연락처'">
              <a :href="`tel:${scope.row.phone}`">{{scope.row.phone}}</a>
              <br>
              <a :href="`mailto:${scope.row.email}`">{{scope.row.email}}</a>
            </template>
            <template v-else-if="key === 'affiliatedTeams'">
              <ul>
                <li v-for="(affiliatedTeam, key) in scope.row.affiliatedTeams"
                    :key="`permission_${key}`">
                  <strong>{{teams[affiliatedTeam.id].name}}</strong> :
                  <span v-if="affiliatedTeam.part !== ''">{{affiliatedTeam.part}}파트 </span>
                  <template v-else>
                    <span v-if="affiliatedTeam.division.length > 0">{{affiliatedTeam.division.join(', ')}}의 </span>
                  </template>
                  <span>{{affiliatedTeam.job.join(',')}}</span>
                </li>
              </ul>
            </template>
            <template v-else>
              {{scope.row[key]}}
            </template>
          </template>
        </el-table-column>
      </template>
    </el-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CheckAffiliatedTeamChangedDialog from '@/container/CheckAffiliatedTeamChangedDialog';
import EditAffiliatedTeam from '@/components/EditAffiliatedTeam';

import getClassNameByException from '@/filters/getClassNameByException';
import getDeleteAnEmptyPermission from '@/filters/getDeleteAnEmptyPermission';
import filterTeamView from '@/filters/getTeamViewData';
import filterMemberView from '@/filters/getMemberViewData';
import getName from '@/mixins/getName';
import checkLoginUserPermission from '@/mixins/checkLoginUserPermission';

export default {
  filters: {
    getClassNameByException,
    getDeleteAnEmptyPermission,
    filterTeamView,
    filterMemberView,
  },
  mixins: [
    getName,
    checkLoginUserPermission,
  ],
  components: {
    EditAffiliatedTeam,
    CheckAffiliatedTeamChangedDialog,
  },
  computed: {
    ...mapGetters([
      'base',
      'isLoading',
      'loginUser',
      'categories',
      'positions',
      'teams',
      'services',
      'members',
      'selectedMember',
    ]),
  },
  watch: {
    members() {
      const hash = location.hash;

      if (this.selectedMember) {
        setTimeout(() => {
          this.members.forEach((member) => {
            if (this.selectedMember && this.selectedMember.id === member.id) {
              this.moveScroll(this.selectedMember);
              this.handleExpandChange(this.selectedMember);
              this.selectedMemberSetting(this.selectedMember, true);
            }
          });
        }, 1);
      } else if (hash) {
        setTimeout(() => {
          this.members.forEach((member) => {
            if (hash.split('#')[1].toUpperCase() === member.id) {
              this.moveScroll(member);
              this.handleExpandChange(member);
              this.selectedMemberSetting(member, true);
            }
          });
        }, 1);
      }
    },
  },
  methods: {
    getTeamPermission(affiliatedTeamId, serviceId, domainId) {
      const permissionList = this.teams[affiliatedTeamId].viewData[serviceId].permissionList;

      return permissionList.includes(domainId) ? 'allowed-by-the-team' : 'not-allowed-by-the-team';
    },

    handleSelectMember(row) {
      this.handleExpandChange(row);
      this.selectedMemberSetting(row);
    },

    handleExpandChange(row) {
      const id = row.id;
      const lastId = this.expandRowKeys[0];

      this.expandRowKeys = id === lastId ? [] : [id];
    },

    selectedMemberSetting(row, isUpdate) {
      if (this.selectedMember) {
        if (this.selectedMember.id !== row.id) {
          this.makeMemberViewData(row);
        } else if (isUpdate) {
          this.makeMemberViewData(row, isUpdate);
        } else {
          this.makeMemberViewData(null);
        }
      } else {
        this.makeMemberViewData(row);
      }
    },

    makeMemberViewData(row, isUpdate) {
      if (row) {
        const copiedMember = JSON.parse(JSON.stringify(row));
        const rowAffiliatedTeams = row.affiliatedTeams;
        const copiedAffiliatedTeams = {};

        Object.keys(rowAffiliatedTeams).forEach((teamId) => {
          copiedAffiliatedTeams[teamId] = copiedMember.affiliatedTeams[teamId];
        });
        copiedMember.affiliatedTeams = copiedAffiliatedTeams;
        this.copiedMember = copiedMember;
        if ((row.proc_status === 1) || isUpdate) {
          this.$store.commit('SET_SELECTED_MEMBER_DATA', row);
        } else {
          this.$store.dispatch('GET_MEMBER_DATA', row);
        }
      } else {
        this.$store.commit('SET_SELECTED_MEMBER_DATA', row);
        this.copiedMember = null;
      }
    },

    moveScroll(row) {
      window.scrollTo({
        top: document.querySelector(`.${row.id}`).offsetTop,
        behavior: 'smooth',
      });
    },

    deleteAnEmptyPermissionList(permissionData) {
      return getDeleteAnEmptyPermission(permissionData, 'gggg');
    },

    findMembersByJob(jobId) {
      const members = [];

      this.members.forEach((member) => {
        Object.keys(member.affiliatedTeams).forEach((teamId) => {
          if (member.affiliatedTeams[teamId].job.includes(jobId)) {
            members.push(member.id);
          }
        });
      });
      return members;
    },

    getClass(action) {
      return getClassNameByException(action);
    },

    changeAction(serviceId, domainId, actionId, teamId) {
      this.makeException(serviceId, domainId, actionId, teamId);
    },

    changeTag(member, teamId, serviceId) {
      const affiliatedTeamData = member.affiliatedTeams[teamId];
      const viewData = affiliatedTeamData.viewData;
      const actions = affiliatedTeamData.actions[serviceId];
      const tags = affiliatedTeamData.tags[serviceId];

      Object.keys(viewData[serviceId]).forEach((domainId) => {
        Object.keys(this.services[serviceId].action_group).forEach((actionId) => {
          if (
            this.teams[teamId].viewData[serviceId].selectedPermissionsByTag.includes(domainId) &&
            actions.includes(actionId) &&
            affiliatedTeamData.useRangeGroup
          ) {
            viewData[serviceId][domainId][actionId].selected = true;
            viewData[serviceId][domainId][actionId].isFilter = true;
          } else {
            viewData[serviceId][domainId][actionId].selected = false;
            viewData[serviceId][domainId][actionId].isFilter = false;
          }
        });
      });

      this.makeTagException(member, serviceId, `tag:${tags}`, actions, teamId);
    },

    makeTagException(member, serviceId, domainId, action, teamId) {
      const affiliatedTeamData = member.affiliatedTeams[teamId];
      const returnExceptions = [];
      const serviceException = [];

      if (affiliatedTeamData.useRangeGroup) {
        action.forEach((actionKey) => {
          returnExceptions.push(`${serviceId}-${domainId}-${actionKey}`);
        });
      }
      affiliatedTeamData.exception.forEach((threeWord) => {
        const pathSplit = threeWord.split('-');

        if (pathSplit[0] !== serviceId) {
          returnExceptions.push(threeWord);
        } else {
          serviceException.push(threeWord);
        }
      });
      affiliatedTeamData.exceptions[serviceId] = serviceException;
      affiliatedTeamData.exception = returnExceptions;
      this.getChangePermissionService(teamId);
    },

    makeException(serviceId, domainId, actionId, teamId) {
      const affiliatedTeamData = this.copiedMember.affiliatedTeams[teamId];
      const threeWord = `${serviceId}-${domainId}-${actionId}`;
      let newExceptions = [];

      if (!affiliatedTeamData.exception.includes(threeWord)) {
        newExceptions = [threeWord, ...affiliatedTeamData.exception];
      } else {
        affiliatedTeamData.exception.forEach((exception) => {
          if (exception !== threeWord) {
            newExceptions.push(exception);
          }
        });
      }
      affiliatedTeamData.exception = newExceptions;
      this.getChangePermissionService(teamId);
    },

    getChangePermissionService(affiliatedTeamId) {
      const agreements = [];
      const beforeTeam = this.selectedMember.affiliatedTeams[affiliatedTeamId];
      const afterTeam = this.copiedMember.affiliatedTeams[affiliatedTeamId];
      const beforeViewData = beforeTeam.viewData;

      Object.keys(beforeViewData).forEach((serviceId) => {
        const agreement = {
          teamId: affiliatedTeamId,
          serviceId,
          date: new Date(),
          agree: null,
          requestor: this.loginUser.id,
          admin: `admin_${serviceId}`,
          signed: '',
          comment: '',
          exception: [],
        };

        afterTeam.exception.forEach((threeWord) => {
          const threeWordSplit = threeWord.split('-');

          if (serviceId === threeWordSplit[0]) {
            agreement.exception.push(threeWord);
          }
        });

        const beforeAffiliatedTeam = beforeTeam.exceptions[serviceId].sort();
        const afterAffiliatedTeam = agreement.exception.sort();
        const isSamePermission =
          beforeAffiliatedTeam.length === afterAffiliatedTeam.length &&
          beforeAffiliatedTeam.every((element, index) => element === afterAffiliatedTeam[index]);

        if (!isSamePermission) {
          agreements.push(agreement);
        }
      });
      this.copiedMember.affiliatedTeams[affiliatedTeamId].agreements = agreements;
    },

    handleEditAffiliatedTeamRoleRequest(editAffiliatedTeamId) {
      Object.keys(this.copiedMember.affiliatedTeams).forEach((affiliatedTeamId) => {
        const affiliatedTeam = this.copiedMember.affiliatedTeams[affiliatedTeamId];

        if (affiliatedTeam.id === editAffiliatedTeamId) {
          const editAffiliatedTeam = JSON.parse(JSON.stringify(affiliatedTeam));

          editAffiliatedTeam.member_id = this.copiedMember.id;
          editAffiliatedTeam.requestor = this.loginUser.id;
          editAffiliatedTeam.job = ['developer_server'];
          delete editAffiliatedTeam.viewData;
          this.$store.dispatch('SUBMIT_MEMBER_AFFILIATED_TEAM_ROLE_REQUEST', editAffiliatedTeam);
        }
      });
      this.handleExpandChange(this.copiedMember);
    },

    handleEditAffiliatedTeamRoleRequestWithdraw(requestId) {
      this.$store.dispatch('SUBMIT_MEMBER_AFFILIATED_TEAM_ROLE_REQUEST_WITHDRAW', requestId);
    },

    handleEditAffiliatedTeamRoleRequestAgree(requestId, agreement, isAgree) {
      this.$store.dispatch('SUBMIT_MEMBER_AFFILIATED_TEAM_ROLE_REQUEST_AGREE', {
        ...agreement,
        agree: isAgree,
        date: new Date(),
        signed: this.loginUser.id,
        request_id: requestId,
      });
      this.handleExpandChange(this.copiedMember);
    },

    handleEditAffiliatedTeamRoleRequestApprove(editAffiliatedTeam, isApprove) {
      this.$store.dispatch('SUBMIT_MEMBER_AFFILIATED_TEAM_ROLE_REQUEST_APPROVE', {
        ...editAffiliatedTeam.approval,
        date: new Date(),
        approve: isApprove,
        admin: 'admin_authority',
        signed: this.loginUser.id,
        request_id: editAffiliatedTeam.request_id,
      });
      this.handleExpandChange(this.copiedMember);
    },

    handleEditMember() {
      const submitData = JSON.parse(JSON.stringify(this.copiedMember));

      delete submitData.viewData;
      this.$store.dispatch('SUBMIT_MEMBER_EDIT_DATA', submitData);
      this.handleExpandChange(this.copiedMember);
    },
  },
  data() {
    return {
      name: 'MemberList',
      localIndicator: [
        'img_url',
        'name',
        '연락처',
        'affiliatedTeams',
      ],
      activeTeamId: '',
      dialogVisible: false,
      copiedMember: {},
      expandRowKeys: [],
      collapseAgreement: [],
    };
  },
};
</script>

<style lang="scss">
  .permission {
    .disabled {
      color: #ccc;
    }
    .disabledDefault {
      color: blue;
      opacity: 0.5;
    }
    .disabledAdd {
      color: red;
      opacity: 0.5;
    }
    .addException {
      color: red;
    }
    .removeException {
      color: orange;
    }
    .default {
      color: blue;
    }
    .normal {
      color: black;
    }
  }
  .el-select .el-input {
    /*width: 110px;*/
  }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }

  .MemberList {
    .el-form-item {
      margin-bottom: 0;
    }
    .el-table__expanded-cell {
      padding: 20px 10px;
    }

    .allowed-by-the-team {
      color: blue;
    }
    .not-allowed-by-the-team {
      opacity: 0.5;
    }
  }
</style>



// WEBPACK FOOTER //
// src/container/MemberList.vue